/* Package JSON Import will be here */
import {
    combineReducers
} from 'redux';
/* Package JSON Import will be here */

/* Project Import will be here */
import Reducer from './reducer';
/* Project Import will be here */

export default combineReducers({
    Reducer
});
